// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeTypeSlider-errorMessage-iK680 {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.HomeTypeSlider-space1-wotEC {
	margin-bottom: 6px !important;
}
.HomeTypeSlider-space2-txNfL {
	margin-bottom: 12px !important;
}
.HomeTypeSlider-space3-TR3DP {
	margin-bottom: 18px !important;
}
.HomeTypeSlider-space4-u8uqI {
	margin-bottom: 24px !important;
}
.HomeTypeSlider-space5-HqKe6 {
	margin-bottom: 30px !important;
}
.HomeTypeSlider-space6-Ja8cA {
	margin-bottom: 36px !important;
}
.HomeTypeSlider-space7-lYT6i {
	margin-bottom: 42px !important;
}
.HomeTypeSlider-spaceTop8-kQzKu {
	margin-bottom: 48px !important;
}
.HomeTypeSlider-spaceTop1-OAPa2 {
	margin-top: 6px !important;
}
.HomeTypeSlider-spaceTop2-QrFaE {
	margin-top: 12px !important;
}
.HomeTypeSlider-spaceTop3-JPf8R {
	margin-top: 18px !important;
}
.HomeTypeSlider-spaceTop4-szFoj {
	margin-top: 24px !important;
}
.HomeTypeSlider-spaceTop5-NrTXj {
	margin-top: 30px !important;
}
.HomeTypeSlider-spaceTop6-exSL2 {
	margin-top: 36px !important;
}
.HomeTypeSlider-spaceTop7-IXtEU {
	margin-top: 42px !important;
}
.HomeTypeSlider-spaceTop8-kQzKu {
	margin-top: 48px !important;
}
.HomeTypeSlider-noMargin-enMNU {
	margin: 0px !important;
}
.HomeTypeSlider-padding1-nTD3z {
	padding-bottom: 6px !important;
}
.HomeTypeSlider-padding2-cIa1V {
	padding-bottom: 12px !important;
}
.HomeTypeSlider-padding3-bGUJS {
	padding-bottom: 18px !important;
}
.HomeTypeSlider-padding4-qb6J0 {
	padding-bottom: 24px !important;
}
.HomeTypeSlider-padding5-pk_QO {
	padding-bottom: 30px !important;
}
.HomeTypeSlider-padding6-ktqNp {
	padding-bottom: 36px !important;
}
.HomeTypeSlider-padding7-z4kgR {
	padding-bottom: 42px !important;
}
.HomeTypeSlider-paddingTop1-NGICq {
	padding-top: 6px !important;
}
.HomeTypeSlider-paddingTop2-T2qHk {
	padding-top: 12px !important;
}
.HomeTypeSlider-paddingTop3-gESFv {
	padding-top: 18px !important;
}
.HomeTypeSlider-paddingTop4-iFP9h {
	padding-top: 24px !important;
}
.HomeTypeSlider-paddingTop5-MsL1r {
	padding-top: 30px !important;
}
.HomeTypeSlider-paddingTop6-k1f2D {
	padding-top: 36px !important;
}
.HomeTypeSlider-paddingTop7-taGV0 {
	padding-top: 42px !important;
}
.HomeTypeSlider-noPadding-bu535 {
	padding: 0px !important;
}
.HomeTypeSlider-textBold-U6VqM {
	font-weight: 500 !important;
}
.HomeTypeSlider-textBolder-jucfX {
	font-weight: 700 !important;
}
.HomeTypeSlider-textNormal-QVdEe {
	font-weight: normal !important;
}
.HomeTypeSlider-spaceBottom20-sHcQS {
	margin-bottom: 20px;
}
.HomeTypeSlider-spaceBottom10-FEzcC {
	margin-bottom: 10px;
}
.HomeTypeSlider-marginNone-kIsr6 {
	margin: 0;
}
.HomeTypeSlider-spaceBottom15-Bh3S0 {
	margin-bottom: 15px;
}
.HomeTypeSlider-marginTopNone-NqUGb {
	margin-top: 0;
}
.HomeTypeSlider-spaceTop11-_jlVq {
	margin-top: 11px;
}
.HomeTypeSlider-spaceTop21-drCsZ {
	margin-top: 21px;
}
.HomeTypeSlider-spaceTop20-buz47 {
	margin-top: 20px;
}
.HomeTypeSlider-spaceTop10-HB5Jt {
	margin-top: 10px;
}
/*New Design Text Colors */
.HomeTypeSlider-textDarkBlue-nwXie {
	color: rgb(20, 39, 94) !important;
}
.HomeTypeSlider-textLightBlue-j_UIS {
	color: rgb(57, 87, 106) !important;
}
.HomeTypeSlider-textLightSandleGreen-UT4vV {
	color: rgb(76, 86, 41) !important;
}
.HomeTypeSlider-textLightBrown-F5gAi {
	color: rgb(115, 79, 33) !important;
}
.HomeTypeSlider-textMediumMaroon-Q4O65 {
	color: rgb(87, 37, 51) !important;
}
.HomeTypeSlider-textBrown-oJlwk {
	color: rgb(160, 47, 24) !important;
}
.HomeTypeSlider-textMaroon-RCAvC {
	color: rgb(155, 49, 67) !important;
}
.HomeTypeSlider-textDarkBrown-cJrcm {
	color: rgb(83, 18, 16) !important;
}
.HomeTypeSlider-textMediumBrown-ROUU3 {
	color: rgb(142, 28, 10) !important;
}
.HomeTypeSlider-textSkyBlue-iACRp {
	color: rgb(37, 117, 141) !important;
}
.HomeTypeSlider-textGray-rDeBb {
	color: rgb(77, 65, 51) !important;
}
.HomeTypeSlider-btn-EcLTB,
.HomeTypeSlider-btn-EcLTB:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 6px 12px !important;
	width: auto;
	outline: 0 !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 4px !important;
	background: var(--background-primary) !important;
	color: var(--primary-btn-foreground) !important;
}
.HomeTypeSlider-btn-EcLTB:hover {
	background: var(--primary-border) !important;
	outline: 0 !important;
}
.HomeTypeSlider-btnPrimary-yIOkU,
.HomeTypeSlider-btnPrimary-yIOkU:focus {
	border-color: var(--primary-bg) !important;
	background-color: var(--primary-bg) !important;
	color: var(--primary-btn-foreground) !important;
}
.HomeTypeSlider-btnPrimary-yIOkU:hover {
	border-color: var(--primary-bg-hover) !important;
	background-color: var(--primary-bg-hover) !important;
	color: var(--primary-btn-foreground) !important;
}
.HomeTypeSlider-btnPrimaryBorder-JtvrU,
.HomeTypeSlider-btnPrimaryBorder-JtvrU:focus {
	border-color: var(--secondary-oscuro) !important;
	color: var(--secondary-oscuro) !important;
	background-color: var(--background-primary) !important;
}
.HomeTypeSlider-btnPrimaryBorder-JtvrU:hover {
	border-color: var(--primary-bg-hover) !important;
	color: var(--primary-bg-hover) !important;
	background-color: var(--background-primary) !important;
}
.HomeTypeSlider-btnLink-LRlyB,
.HomeTypeSlider-btnLink-LRlyB:focus,
.HomeTypeSlider-btnLink-LRlyB:hover {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent !important;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: inherit;
	border: 0px !important;
}
.HomeTypeSlider-searchFilterPopover-WBZsc {
	position: absolute;
	top: 51px;
	left: 0px;
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	display: inline-block;
	max-height: 65vh;
	visibility: visible;
	background: var(--background-primary);
	-webkit-box-shadow: 0px 0px 10px var(--primary-box-shadow);
	        box-shadow: 0px 0px 10px var(--primary-box-shadow);
	border-radius: 14px;
}
.HomeTypeSlider-searchFilterPopoverFull-xfjPd {
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 66%;
	height: initial;
	-webkit-box-shadow: none;
	        box-shadow: none;
	visibility: visible;
	top: 148px;
	background-color: var(--modal-bg);
	border-radius: 4px;
	border-width: initial;
	border-style: none;
	border-color: initial;
	-o-border-image: initial;
	   border-image: initial;
}
.HomeTypeSlider-searchFilterPopoverOverlay-wrSUr {
	position: fixed;
	height: 100vh;
	width: 100%;
	top: 64px;
	z-index: 2;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	background: rgba(255, 255, 255, 0.85);
	left: 0;
	right: 0;
	visibility: visible;
	bottom: 0;
	-webkit-overflow-scrolling: touch;
}
.HomeTypeSlider-dateFilterpopVerlayHeight-ZS0xq {
	max-height: 100%;
}
.HomeTypeSlider-dateFilterpopVerlayContentHeight-S14PB {
	min-height: 100% !important;
}
.HomeTypeSlider-searchFilterCloseIcon-IgVKq {
	font-size: 30px;
	color: var(--secondary-foreground);
}
.HomeTypeSlider-searchFilterPopoverFooter-lTp04 {
	width: 100%;
	position: relative;
	line-height: 0;
}
.HomeTypeSlider-displayTable-hR5kc {
	display: table;
	width: 100%;
	vertical-align: middle;
}
.HomeTypeSlider-displayTableRow-eZky5 {
	display: table-row;
	vertical-align: middle;
}
.HomeTypeSlider-displayTableCell-GRj7H {
	display: table-cell;
	vertical-align: middle;
}
.HomeTypeSlider-displayInlineBlock-Ts4_s {
	display: inline-block;
	vertical-align: top;
	white-space: normal;
}
.HomeTypeSlider-fullWidth-GWZXL {
	width: 100% !important;
}
.HomeTypeSlider-captionTitle-Zk89l {
	font-size: 16px;
	color: var(--primary-foreground);
}
.HomeTypeSlider-showTabletSection-itsJn {
	display: none !important;
}
.HomeTypeSlider-blockRadioButton-D8NQk {
	margin-top: 0;
	max-width: 320px;
	border: 1px solid var(--primary-border);
	padding: 20px;
}
.HomeTypeSlider-jumboSelect-Govah {
	height: 58px !important;
	font-size: 16px !important;
	padding: 15px 47px 20px 20px !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 4px !important;
}
.HomeTypeSlider-jumboSelectPadding-eLSQq {
	padding: 15px 50px 20px 20px !important;
}
.HomeTypeSlider-commonBorder-pY9WI {
	border: 1px solid var(--primary-border) !important;
	color: var(--secondary-foreground) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	border-radius: 3px !important;
}
.HomeTypeSlider-textAignRight-CAdcp {
	text-align: right;
}
.HomeTypeSlider-textAlignLeft-uuXEo {
	text-align: left;
}
.HomeTypeSlider-textAignCenter-DKigb {
	text-align: center;
}
.HomeTypeSlider-moreFilterTitle-XDfQd {
	font-size: 18px;
}
.HomeTypeSlider-dot-YdIk4 {
	color: var(--secondary-foreground);
	font-size: 12px;
	margin-bottom: 0;
}
/*************************** Header Modal Start **********************/
.HomeTypeSlider-currencyAndLanguageGrid-oCs09 {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 30px;
}
.HomeTypeSlider-activeItem-A1a1C {
	padding: 15px;
	text-align: center;
	font-size: 16px;
	border-radius: 8px;
	cursor: pointer;
	border: 1px solid var(--primary-border);
}
.HomeTypeSlider-activeItem-A1a1C:hover,
.HomeTypeSlider-activeItem-A1a1C:focus,
.HomeTypeSlider-activeItem-A1a1C:active {
	background-color: var(--common-hover-bg);
	color: var(--primary-foreground);
}
.HomeTypeSlider-activeSection-F1W_e:first-child {
	background-color: var(--primary-gray-bg);
	color: var(--primary-foreground);
	border: 1px solid var(--secondary-bg);
	cursor: not-allowed;
}
.HomeTypeSlider-commonCloseModalBtn-WZw5w {
	position: absolute;
	cursor: pointer;
}
.HomeTypeSlider-searchIconCommon-bexmJ {
	margin-right: 3px;
	position: relative;
	top: -1px;
}
.HomeTypeSlider-loginLabel-jCdqC {
	font-size: 16px;
	margin-bottom: 10px;
	font-weight: 600;
}
@media screen and (max-width: 767px) {

	.HomeTypeSlider-dropdownOverflow-ikWWO {
		white-space: break-spaces;
		text-align: left;
	}

	.HomeTypeSlider-currencyAndLanguageGrid-oCs09 {
		grid-template-columns: repeat(2, 1fr);
	}
}
@media (max-width:991px) and (min-width:768px) {
	.HomeTypeSlider-currencyAndLanguageGrid-oCs09 {
		grid-template-columns: repeat(4, 1fr);
	}
}
/*************************** Header Modal End **********************/
.HomeTypeSlider-capitalizeText-ACTe2 {
	text-transform: capitalize;
}
@media screen and (max-width: 767px) {
	.HomeTypeSlider-searchFilterPopoverHeader-Xd7SI {
		position: fixed;
		top: 0;
		z-index: 7;
		left: 0;
		right: 0;
		width: 100%;
		padding: 24px;
		border-bottom: 1px solid var(--primary-border);
		background-color: var(--modal-bg);
		border-radius: 14px 14px 0 0;
	}
}
@media screen and (max-width: 768px) {
	.HomeTypeSlider-searchFilterPopoverFull-xfjPd {
		width: 100%;
		height: 100%;
		top: 0px;
		-webkit-box-shadow: none;
		        box-shadow: none;
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
		border-radius: 14px;
	}

	.HomeTypeSlider-searchFilterPopoverContent-YuYXb {
		height: 100%;
		min-height: 100vh;
		-webkit-overflow-scrolling: touch;
	}

	.HomeTypeSlider-showTabletSection-itsJn {
		display: block !important;
	}

	.HomeTypeSlider-hideTabletSection-OlpOI {
		display: none !important;
	}
}
@media screen and (max-width: 767px) {
	.HomeTypeSlider-searchFilterPopoverFooter-lTp04 {
		position: relative !important;
	}
}
@media screen and (max-width: 350px) {
	.HomeTypeSlider-btnFontsize-zd1wT {
		font-size: 14px !important;
	}
}
@media (max-width: 360px) {
	.HomeTypeSlider-searchFilterCloseIcon-IgVKq {
		font-size: 25px;
	}
}
@media (max-width: 993px) and (min-width: 769px) {
	.HomeTypeSlider-responsiveFontsize-mgAgF {
		font-size: 14px;
	}
}
/*****************Apply Button Alignment Start **********************/
.HomeTypeSlider-applyBtnDesktop-kvsOP {
	text-align: right;
}
@media screen and (max-width: 991px) {
	.HomeTypeSlider-applyBtnDesktop-kvsOP {
		text-align: center;
	}

	.HomeTypeSlider-applyBtnDesktopRight-VpoZh {
		text-align: right !important;
	}

	.HomeTypeSlider-applyBtnDesktopNoPaddingRight-ip40I {
		padding-right: 0px !important;
	}

}
/*****************Apply Button Alignment Start **********************/
.HomeTypeSlider-chip-xpn2s {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    padding: 8px 18px;
    border-radius: 27px;
    background: var(--white-color);
    border: 1px solid var(--primary-color);
    color: var(--primary-color);
    font-size: 20px;
    font-weight: bold;
    font-family: var(--font-family-base);
    cursor: pointer;
    white-space: nowrap;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
}
.HomeTypeSlider-chip-xpn2s:hover {
    background: var(--primary-color);
    color: var(--white-color);
}
.HomeTypeSlider-chipActive-rou7x {
    background: var(--primary-color);
    color: var(--white-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/common.css","webpack://./src/components/SearchListing/Filters/HomeTypeSlider/HomeTypeSlider.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,4BAA4B;CAC5B,WAAW;CACX,qBAAqB;CACrB,kDAAkD;CAClD,6BAA6B;CAC7B,gDAAgD;CAChD,+CAA+C;AAChD;AAEA;CACC,4CAA4C;CAC5C,qBAAqB;AACtB;AAEA;;CAEC,0CAA0C;CAC1C,8CAA8C;CAC9C,+CAA+C;AAChD;AAEA;CACC,gDAAgD;CAChD,oDAAoD;CACpD,+CAA+C;AAChD;AAEA;;CAEC,gDAAgD;CAChD,yCAAyC;CACzC,sDAAsD;AACvD;AAEA;CACC,gDAAgD;CAChD,yCAAyC;CACzC,sDAAsD;AACvD;AAEA;;;CAGC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kCAAkC;CAClC,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB,qCAAqC;CACrC,0DAAkD;SAAlD,kDAAkD;CAClD,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,SAAS;CACT,WAAW;CACX,UAAU;CACV,eAAe;CACf,wBAAgB;SAAhB,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CACV,iCAAiC;CACjC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,wBAAqB;IAArB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,aAAa;CACb,WAAW;CACX,SAAS;CACT,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qCAAqC;CACrC,OAAO;CACP,QAAQ;CACR,mBAAmB;CACnB,SAAS;CACT,iCAAiC;AAClC;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,cAAc;CACd,WAAW;CACX,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;AAEA;CACC,wBAAwB;AACzB;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,uCAAuC;CACvC,aAAa;AACd;AAEA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,uCAAuC;CACvC,kDAAkD;CAClD,6BAA6B;AAC9B;AAEA;CACC,uCAAuC;AACxC;AAEA;CACC,kDAAkD;CAClD,6CAA6C;CAC7C,mCAA2B;SAA3B,2BAA2B;CAC3B,6BAA6B;AAC9B;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,gBAAgB;AACjB;AAEA,sEAAsE;AACtE;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,uCAAuC;AACxC;AAGA;;;CAGC,wCAAwC;CACxC,gCAAgC;AACjC;AAEA;CACC,wCAAwC;CACxC,gCAAgC;CAChC,qCAAqC;CACrC,mBAAmB;AACpB;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;AACV;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;AAGA;;CAEC;EACC,yBAAyB;EACzB,gBAAgB;CACjB;;CAEA;EACC,qCAAqC;CACtC;AACD;AAEA;CACC;EACC,qCAAqC;CACtC;AACD;AAEA,oEAAoE;AAEpE;CACC,0BAA0B;AAC3B;AAEA;CACC;EACC,eAAe;EACf,MAAM;EACN,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,8CAA8C;EAC9C,iCAAiC;EACjC,4BAA4B;CAC7B;AACD;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,wBAAgB;UAAhB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;CACpB;;CAEA;EACC,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;CAClC;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,wBAAwB;CACzB;AACD;AAEA;CACC;EACC,6BAA6B;CAC9B;AACD;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA,qEAAqE;AAErE;CACC,iBAAiB;AAClB;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;;AAED;AAEA,qEAAqE;AC1XrE;IACI,2BAAoB;IAApB,2BAAoB;IAApB,oBAAoB;IACpB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,eAAe;IACf,mBAAmB;IACnB,iCAAyB;IAAzB,yBAAyB;AAC7B;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import 'utils.css';\n@import 'helpers.css';\n\n.btn,\n.btn:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 6px 12px !important;\n\twidth: auto;\n\toutline: 0 !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 4px !important;\n\tbackground: var(--background-primary) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btn:hover {\n\tbackground: var(--primary-border) !important;\n\toutline: 0 !important;\n}\n\n.btnPrimary,\n.btnPrimary:focus {\n\tborder-color: var(--primary-bg) !important;\n\tbackground-color: var(--primary-bg) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btnPrimary:hover {\n\tborder-color: var(--primary-bg-hover) !important;\n\tbackground-color: var(--primary-bg-hover) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btnPrimaryBorder,\n.btnPrimaryBorder:focus {\n\tborder-color: var(--secondary-oscuro) !important;\n\tcolor: var(--secondary-oscuro) !important;\n\tbackground-color: var(--background-primary) !important;\n}\n\n.btnPrimaryBorder:hover {\n\tborder-color: var(--primary-bg-hover) !important;\n\tcolor: var(--primary-bg-hover) !important;\n\tbackground-color: var(--background-primary) !important;\n}\n\n.btnLink,\n.btnLink:focus,\n.btnLink:hover {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent !important;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: inherit;\n\tborder: 0px !important;\n}\n\n.searchFilterPopover {\n\tposition: absolute;\n\ttop: 51px;\n\tleft: 0px;\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tdisplay: inline-block;\n\tmax-height: 65vh;\n\tvisibility: visible;\n\tbackground: var(--background-primary);\n\tbox-shadow: 0px 0px 10px var(--primary-box-shadow);\n\tborder-radius: 14px;\n}\n\n.searchFilterPopoverFull {\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: 0px;\n\twidth: 66%;\n\theight: initial;\n\tbox-shadow: none;\n\tvisibility: visible;\n\ttop: 148px;\n\tbackground-color: var(--modal-bg);\n\tborder-radius: 4px;\n\tborder-width: initial;\n\tborder-style: none;\n\tborder-color: initial;\n\tborder-image: initial;\n}\n\n.searchFilterPopoverOverlay {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100%;\n\ttop: 64px;\n\tz-index: 2;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tbackground: rgba(255, 255, 255, 0.85);\n\tleft: 0;\n\tright: 0;\n\tvisibility: visible;\n\tbottom: 0;\n\t-webkit-overflow-scrolling: touch;\n}\n\n.dateFilterpopVerlayHeight {\n\tmax-height: 100%;\n}\n\n.dateFilterpopVerlayContentHeight {\n\tmin-height: 100% !important;\n}\n\n.searchFilterCloseIcon {\n\tfont-size: 30px;\n\tcolor: var(--secondary-foreground);\n}\n\n.searchFilterPopoverFooter {\n\twidth: 100%;\n\tposition: relative;\n\tline-height: 0;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n\tvertical-align: middle;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\tvertical-align: middle;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twhite-space: normal;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n}\n\n.captionTitle {\n\tfont-size: 16px;\n\tcolor: var(--primary-foreground);\n}\n\n.showTabletSection {\n\tdisplay: none !important;\n}\n\n.blockRadioButton {\n\tmargin-top: 0;\n\tmax-width: 320px;\n\tborder: 1px solid var(--primary-border);\n\tpadding: 20px;\n}\n\n.jumboSelect {\n\theight: 58px !important;\n\tfont-size: 16px !important;\n\tpadding: 15px 47px 20px 20px !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 4px !important;\n}\n\n.jumboSelectPadding {\n\tpadding: 15px 50px 20px 20px !important;\n}\n\n.commonBorder {\n\tborder: 1px solid var(--primary-border) !important;\n\tcolor: var(--secondary-foreground) !important;\n\tbox-shadow: none !important;\n\tborder-radius: 3px !important;\n}\n\n.textAignRight {\n\ttext-align: right;\n}\n\n.textAlignLeft {\n\ttext-align: left;\n}\n\n.textAignCenter {\n\ttext-align: center;\n}\n\n.moreFilterTitle {\n\tfont-size: 18px;\n}\n\n.dot {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 12px;\n\tmargin-bottom: 0;\n}\n\n/*************************** Header Modal Start **********************/\n.currencyAndLanguageGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tgap: 30px;\n}\n\n.activeItem {\n\tpadding: 15px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tborder-radius: 8px;\n\tcursor: pointer;\n\tborder: 1px solid var(--primary-border);\n}\n\n\n.activeItem:hover,\n.activeItem:focus,\n.activeItem:active {\n\tbackground-color: var(--common-hover-bg);\n\tcolor: var(--primary-foreground);\n}\n\n.activeSection:first-child {\n\tbackground-color: var(--primary-gray-bg);\n\tcolor: var(--primary-foreground);\n\tborder: 1px solid var(--secondary-bg);\n\tcursor: not-allowed;\n}\n\n.commonCloseModalBtn {\n\tposition: absolute;\n\tcursor: pointer;\n}\n\n.searchIconCommon {\n\tmargin-right: 3px;\n\tposition: relative;\n\ttop: -1px;\n}\n\n.loginLabel {\n\tfont-size: 16px;\n\tmargin-bottom: 10px;\n\tfont-weight: 600;\n}\n\n\n@media screen and (max-width: 767px) {\n\n\t.dropdownOverflow {\n\t\twhite-space: break-spaces;\n\t\ttext-align: left;\n\t}\n\n\t.currencyAndLanguageGrid {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n@media (max-width:991px) and (min-width:768px) {\n\t.currencyAndLanguageGrid {\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t}\n}\n\n/*************************** Header Modal End **********************/\n\n.capitalizeText {\n\ttext-transform: capitalize;\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverHeader {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tz-index: 7;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\tpadding: 24px;\n\t\tborder-bottom: 1px solid var(--primary-border);\n\t\tbackground-color: var(--modal-bg);\n\t\tborder-radius: 14px 14px 0 0;\n\t}\n}\n\n@media screen and (max-width: 768px) {\n\t.searchFilterPopoverFull {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0px;\n\t\tbox-shadow: none;\n\t\tmax-height: 100%;\n\t\t-webkit-overflow-scrolling: touch;\n\t\tborder-radius: 14px;\n\t}\n\n\t.searchFilterPopoverContent {\n\t\theight: 100%;\n\t\tmin-height: 100vh;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.showTabletSection {\n\t\tdisplay: block !important;\n\t}\n\n\t.hideTabletSection {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverFooter {\n\t\tposition: relative !important;\n\t}\n}\n\n@media screen and (max-width: 350px) {\n\t.btnFontsize {\n\t\tfont-size: 14px !important;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.searchFilterCloseIcon {\n\t\tfont-size: 25px;\n\t}\n}\n\n@media (max-width: 993px) and (min-width: 769px) {\n\t.responsiveFontsize {\n\t\tfont-size: 14px;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n\n.applyBtnDesktop {\n\ttext-align: right;\n}\n\n@media screen and (max-width: 991px) {\n\t.applyBtnDesktop {\n\t\ttext-align: center;\n\t}\n\n\t.applyBtnDesktopRight {\n\t\ttext-align: right !important;\n\t}\n\n\t.applyBtnDesktopNoPaddingRight {\n\t\tpadding-right: 0px !important;\n\t}\n\n}\n\n/*****************Apply Button Alignment Start **********************/","@import '../../../../components/common.css';\n\n.chip {\n    display: inline-flex;\n    align-items: center;\n    padding: 8px 18px;\n    border-radius: 27px;\n    background: var(--white-color);\n    border: 1px solid var(--primary-color);\n    color: var(--primary-color);\n    font-size: 20px;\n    font-weight: bold;\n    font-family: var(--font-family-base);\n    cursor: pointer;\n    white-space: nowrap;\n    transition: all 0.2s ease;\n}\n\n.chip:hover {\n    background: var(--primary-color);\n    color: var(--white-color);\n}\n\n.chipActive {\n    background: var(--primary-color);\n    color: var(--white-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `HomeTypeSlider-errorMessage-iK680`,
	"space1": `HomeTypeSlider-space1-wotEC`,
	"space2": `HomeTypeSlider-space2-txNfL`,
	"space3": `HomeTypeSlider-space3-TR3DP`,
	"space4": `HomeTypeSlider-space4-u8uqI`,
	"space5": `HomeTypeSlider-space5-HqKe6`,
	"space6": `HomeTypeSlider-space6-Ja8cA`,
	"space7": `HomeTypeSlider-space7-lYT6i`,
	"spaceTop8": `HomeTypeSlider-spaceTop8-kQzKu`,
	"spaceTop1": `HomeTypeSlider-spaceTop1-OAPa2`,
	"spaceTop2": `HomeTypeSlider-spaceTop2-QrFaE`,
	"spaceTop3": `HomeTypeSlider-spaceTop3-JPf8R`,
	"spaceTop4": `HomeTypeSlider-spaceTop4-szFoj`,
	"spaceTop5": `HomeTypeSlider-spaceTop5-NrTXj`,
	"spaceTop6": `HomeTypeSlider-spaceTop6-exSL2`,
	"spaceTop7": `HomeTypeSlider-spaceTop7-IXtEU`,
	"noMargin": `HomeTypeSlider-noMargin-enMNU`,
	"padding1": `HomeTypeSlider-padding1-nTD3z`,
	"padding2": `HomeTypeSlider-padding2-cIa1V`,
	"padding3": `HomeTypeSlider-padding3-bGUJS`,
	"padding4": `HomeTypeSlider-padding4-qb6J0`,
	"padding5": `HomeTypeSlider-padding5-pk_QO`,
	"padding6": `HomeTypeSlider-padding6-ktqNp`,
	"padding7": `HomeTypeSlider-padding7-z4kgR`,
	"paddingTop1": `HomeTypeSlider-paddingTop1-NGICq`,
	"paddingTop2": `HomeTypeSlider-paddingTop2-T2qHk`,
	"paddingTop3": `HomeTypeSlider-paddingTop3-gESFv`,
	"paddingTop4": `HomeTypeSlider-paddingTop4-iFP9h`,
	"paddingTop5": `HomeTypeSlider-paddingTop5-MsL1r`,
	"paddingTop6": `HomeTypeSlider-paddingTop6-k1f2D`,
	"paddingTop7": `HomeTypeSlider-paddingTop7-taGV0`,
	"noPadding": `HomeTypeSlider-noPadding-bu535`,
	"textBold": `HomeTypeSlider-textBold-U6VqM`,
	"textBolder": `HomeTypeSlider-textBolder-jucfX`,
	"textNormal": `HomeTypeSlider-textNormal-QVdEe`,
	"spaceBottom20": `HomeTypeSlider-spaceBottom20-sHcQS`,
	"spaceBottom10": `HomeTypeSlider-spaceBottom10-FEzcC`,
	"marginNone": `HomeTypeSlider-marginNone-kIsr6`,
	"spaceBottom15": `HomeTypeSlider-spaceBottom15-Bh3S0`,
	"marginTopNone": `HomeTypeSlider-marginTopNone-NqUGb`,
	"spaceTop11": `HomeTypeSlider-spaceTop11-_jlVq`,
	"spaceTop21": `HomeTypeSlider-spaceTop21-drCsZ`,
	"spaceTop20": `HomeTypeSlider-spaceTop20-buz47`,
	"spaceTop10": `HomeTypeSlider-spaceTop10-HB5Jt`,
	"textDarkBlue": `HomeTypeSlider-textDarkBlue-nwXie`,
	"textLightBlue": `HomeTypeSlider-textLightBlue-j_UIS`,
	"textLightSandleGreen": `HomeTypeSlider-textLightSandleGreen-UT4vV`,
	"textLightBrown": `HomeTypeSlider-textLightBrown-F5gAi`,
	"textMediumMaroon": `HomeTypeSlider-textMediumMaroon-Q4O65`,
	"textBrown": `HomeTypeSlider-textBrown-oJlwk`,
	"textMaroon": `HomeTypeSlider-textMaroon-RCAvC`,
	"textDarkBrown": `HomeTypeSlider-textDarkBrown-cJrcm`,
	"textMediumBrown": `HomeTypeSlider-textMediumBrown-ROUU3`,
	"textSkyBlue": `HomeTypeSlider-textSkyBlue-iACRp`,
	"textGray": `HomeTypeSlider-textGray-rDeBb`,
	"btn": `HomeTypeSlider-btn-EcLTB`,
	"btnPrimary": `HomeTypeSlider-btnPrimary-yIOkU`,
	"btnPrimaryBorder": `HomeTypeSlider-btnPrimaryBorder-JtvrU`,
	"btnLink": `HomeTypeSlider-btnLink-LRlyB`,
	"searchFilterPopover": `HomeTypeSlider-searchFilterPopover-WBZsc`,
	"searchFilterPopoverFull": `HomeTypeSlider-searchFilterPopoverFull-xfjPd`,
	"searchFilterPopoverOverlay": `HomeTypeSlider-searchFilterPopoverOverlay-wrSUr`,
	"dateFilterpopVerlayHeight": `HomeTypeSlider-dateFilterpopVerlayHeight-ZS0xq`,
	"dateFilterpopVerlayContentHeight": `HomeTypeSlider-dateFilterpopVerlayContentHeight-S14PB`,
	"searchFilterCloseIcon": `HomeTypeSlider-searchFilterCloseIcon-IgVKq`,
	"searchFilterPopoverFooter": `HomeTypeSlider-searchFilterPopoverFooter-lTp04`,
	"displayTable": `HomeTypeSlider-displayTable-hR5kc`,
	"displayTableRow": `HomeTypeSlider-displayTableRow-eZky5`,
	"displayTableCell": `HomeTypeSlider-displayTableCell-GRj7H`,
	"displayInlineBlock": `HomeTypeSlider-displayInlineBlock-Ts4_s`,
	"fullWidth": `HomeTypeSlider-fullWidth-GWZXL`,
	"captionTitle": `HomeTypeSlider-captionTitle-Zk89l`,
	"showTabletSection": `HomeTypeSlider-showTabletSection-itsJn`,
	"blockRadioButton": `HomeTypeSlider-blockRadioButton-D8NQk`,
	"jumboSelect": `HomeTypeSlider-jumboSelect-Govah`,
	"jumboSelectPadding": `HomeTypeSlider-jumboSelectPadding-eLSQq`,
	"commonBorder": `HomeTypeSlider-commonBorder-pY9WI`,
	"textAignRight": `HomeTypeSlider-textAignRight-CAdcp`,
	"textAlignLeft": `HomeTypeSlider-textAlignLeft-uuXEo`,
	"textAignCenter": `HomeTypeSlider-textAignCenter-DKigb`,
	"moreFilterTitle": `HomeTypeSlider-moreFilterTitle-XDfQd`,
	"dot": `HomeTypeSlider-dot-YdIk4`,
	"currencyAndLanguageGrid": `HomeTypeSlider-currencyAndLanguageGrid-oCs09`,
	"activeItem": `HomeTypeSlider-activeItem-A1a1C`,
	"activeSection": `HomeTypeSlider-activeSection-F1W_e`,
	"commonCloseModalBtn": `HomeTypeSlider-commonCloseModalBtn-WZw5w`,
	"searchIconCommon": `HomeTypeSlider-searchIconCommon-bexmJ`,
	"loginLabel": `HomeTypeSlider-loginLabel-jCdqC`,
	"dropdownOverflow": `HomeTypeSlider-dropdownOverflow-ikWWO`,
	"capitalizeText": `HomeTypeSlider-capitalizeText-ACTe2`,
	"searchFilterPopoverHeader": `HomeTypeSlider-searchFilterPopoverHeader-Xd7SI`,
	"searchFilterPopoverContent": `HomeTypeSlider-searchFilterPopoverContent-YuYXb`,
	"hideTabletSection": `HomeTypeSlider-hideTabletSection-OlpOI`,
	"btnFontsize": `HomeTypeSlider-btnFontsize-zd1wT`,
	"responsiveFontsize": `HomeTypeSlider-responsiveFontsize-mgAgF`,
	"applyBtnDesktop": `HomeTypeSlider-applyBtnDesktop-kvsOP`,
	"applyBtnDesktopRight": `HomeTypeSlider-applyBtnDesktopRight-VpoZh`,
	"applyBtnDesktopNoPaddingRight": `HomeTypeSlider-applyBtnDesktopNoPaddingRight-ip40I`,
	"chip": `HomeTypeSlider-chip-xpn2s`,
	"chipActive": `HomeTypeSlider-chipActive-rou7x`
};
module.exports = ___CSS_LOADER_EXPORT___;
